import axios from '../utils/axios';

export default function getPremiumLogs(adminId, params = {}) {
    return axios.get(`/admin/${adminId}/get-premium-job-detail`, { params });
};
